import { memo } from 'react'

import './index.scss'
import Icon from '../Icon'
import { ICON } from '../Icon/data'

type SelectTag = {
  id: string
  label: string
  onDelete: (id: any) => any
}

const SelectTag = memo(({ id, label, onDelete = () => {}}: SelectTag) => {
  return (
    <div className="SelectTag">
      <div className="SelectTag__label">{label}</div>
      <div
        className="SelectTag__button"
        role="button"
        tabIndex={0}
        onClick={() => onDelete(id)}
      >
        <Icon icon={ICON.TRASH} />
      </div>
    </div>
  )
})

export default SelectTag
